import { useState } from 'react';
import { Box, Text } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import AnimatedRadialLines from './AnimatedRadialLines';
import { useGeneralContext } from '../../GeneralContext.js';

const RollDisplay = ({ number, color, success, luckPoint }) => {
  const { triggerFailRoll } = useGeneralContext();
  const [showRadial, setShowRadial] = useState(false);
  const [animationComplete, setAnimationComplete] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 1 }}
      animate={animationComplete ? { opacity: 0 } : { opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div>
        <motion.div
          initial={{
            x: 15,
            y: 15,
            scale: 0.5,
            opacity: 0,
          }}
          animate={{
            x: 0,
            y: 0,
            scale: 1,
            opacity: 1,
          }}
          exit={{ scale: 0.5, opacity: 0 }}
          transition={{ duration: 0.5 }}
          onAnimationComplete={() => {
            if (luckPoint || !success)
              triggerFailRoll(luckPoint ? color : undefined);
            setShowRadial(success);
            setTimeout(() => {
              setAnimationComplete(true);
            }, 2000);
          }}
        >
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="35px"
            height="35px"
            left="12px"
            top="13px"
            position="absolute"
            borderRadius="full"
            bg="white"
            border="2px solid"
            borderColor={color}
            shadow={`0 0 15px ${success ? color : 'transparent'}`}
          >
            <Text fontSize={25} fontWeight="bold" mt="-5px" color={color}>
              {number}
            </Text>
          </Box>
        </motion.div>
        {showRadial && (
          <div>
            <AnimatedRadialLines
              x={30}
              y={30}
              innerDiamater={16}
              outerDiameter={28}
              color={color}
              lineWidth={2}
            />
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default RollDisplay;
